import Icon from '../components/Icon.vue'

Icon.register({
  horse: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M575.9 76.6C575.9 68.5 572.9 60.7 567.3 54.8 563.6 50.8 558.8 45.7 553.6 40.3 564.7 33.5 573.1 22.8 575.8 9.6 576.9 4.7 573 0 567.9 0H447.9C377.2 0 319.9 57.3 319.9 128H160C131.2 128 105.6 141 88 161.1V160C39.5 160 0 199.5 0 248V304C0 312.8 7.2 320 16 320H32C40.8 320 48 312.8 48 304V248C48 234.8 54.9 223.6 64.8 216.3 64.6 218.9 64 221.4 64 224 64 251.6 75.8 276.4 94.5 293.9L68.8 362.5A63.9-63.9 0 0 1 66.7 400.5L91.5 499.9A16-16 0 0 1 107 512H173C183.4 512 191 502.2 188.5 492.1L162.2 386.9 186 323.3 320 345.6V496C320 504.8 327.2 512 336 512H400C408.8 512 416 504.8 416 496V318.2C435.7 298 448 270.5 448 240 448 239.8 447.9 239.6 447.9 239.4V136.9L463.9 144 482.8 181.7C490.3 196.6 507.9 203.3 523.3 197.1L555.9 184A32-32 0 0 1 576 154.3L575.9 76.6zM511.9 96C503.1 96 495.9 88.8 495.9 80S503.1 64 511.9 64 527.9 71.2 527.9 80 520.8 96 511.9 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/horse.js
// module id = lWEB
// module chunks = 144